import axios from 'axios';
// ---- external imports ----

import { CreateTradeshowModel, CreateHiredTradeshowBoothModel } from '~/models';
// ---- internal imports ----

import { getBaseUrl } from '../lib/helpers';
// ---- parent imports ----

import { getRequestHeaders } from './headers';
import { formatResponse } from './utlis';
import ApiService from './axiosInterceptor.service';
import { TRADESHOWS_POST_APIS } from '../endpoints';
// ---- local imports ----

class TradeshowService {

	async fetchAll() {
		const response = await ApiService.request({
			method: 'GET',
			headers: getRequestHeaders(),
			url: `${getBaseUrl()}/tradeshows`
		});


		const formattedResponse = formatResponse(response);

		if (!formattedResponse.isSuccess) {
			return formattedResponse;
		}

		const rawTradeshowList = response.data;
		formattedResponse.data = rawTradeshowList.map(CreateTradeshowModel);

		return formattedResponse;
	};

	async fetchHired(gameUserId) {
		const response = await ApiService.request({
			method: 'GET',
			headers: getRequestHeaders(),
			url: `${getBaseUrl()}/game_users/${gameUserId}/hired_tradeshow_booths`,
		});

		const formattedResponse = formatResponse(response);

		if (!formattedResponse.isSuccess) {
			return formattedResponse;
		}

		const rawHiredTradeshowBooths = response.data;
		formattedResponse.data = rawHiredTradeshowBooths.map(CreateHiredTradeshowBoothModel);

		return formattedResponse;
	};

	async hire(tradeshowId, gameUserId) {
		const data = {
			/* eslint-disable camelcase */
			tradeshow_id: tradeshowId,
			game_user_id: gameUserId,
			/* eslint-enable camelcase */
		};

		const response = await ApiService.request({
			method: 'POST',
			headers: getRequestHeaders(),
			data: JSON.stringify(data),
			url: `${getBaseUrl()}/tradeshows/${TRADESHOWS_POST_APIS.HIRE_TRADESHOW}`,
		});
		
		const formattedResponse = formatResponse(response);

		if (!formattedResponse.isSuccess) {
			return formattedResponse;
		}

		const { hiredTradeshow, notifications } = response.data;
		const hiredTradeshowBooth = CreateHiredTradeshowBoothModel(hiredTradeshow);

		formattedResponse.data =  { hiredTradeshowBooth, notifications };

		return formattedResponse;
	};
}

export default new TradeshowService();
